import Notifications from 'vue-notification';

export default {
  install(Vue) {
    Vue.use(Notifications, { name: 'notification' });
    Vue.prototype.$notify = Vue.prototype.$notification;
    delete Vue.prototype.$notification;
  },
};
